import { render } from "./category.vue?vue&type=template&id=1ed9c49c"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
script.render = render

export default script